/**
 * `sentry.sample_rate` is set by Sentry after the decision to sample the trace is made.
 * This attribute is set by GitBook before the decision is made, to influence the sampling decision.
 */
export const SENTRY_SPAN_ATTRIBUTE_SAMPLE_RATE = 'gitbook.sample_rate';
